//验证手机号
const isPoneFun = function (pone) {
    var myreg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
    if (!myreg.test(pone)) {
        return false;
    } else {
        return true;
    }
}
// 生成20位随机数
const s20 = function () {
    var data = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z", "a", "b", "c", "d", "e", "f", "g", "h", "i", "j", "k", "l", "m", "n", "o", "p", "q", "r", "s", "t", "u", "v", "w", "x", "y", "z"];

    var result = "";
    for (var i = 0; i < 20; i++) {
        var r = Math.floor(Math.random() * 62);		//取得0-62间的随机数，目的是以此当下标取数组data里的值！
        result += data[r];		//输出20次随机数的同时，让rrr加20次，就是20位的随机字符串了。
    }
    return result
}
// 将base64转换为files
const base64ToFiles = function (dataurl) {
    let arr = dataurl.split(',')
    let mime = arr[0].match(/:(.*?);/)[1]
    let suffix = mime.split('/')[1]
    let bstr = atob(arr[1])
    let n = bstr.length
    let u8arr = new Uint8Array(n)
    while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
    }
    let blob = new Blob([u8arr], { type: mime })
    let files = new window.File([blob], `.${suffix}`, { type: mime })
    return files
}
const timeConvert = function(timestamp,num){
    //num:0 YYYY-MM-DD  num:1  YYYY-MM-DD hh:mm:ss  num:2 今天或几月几日// timestamp:时间戳 
    timestamp = timestamp.length==10?timestamp*1000:timestamp;
    var date = new Date(timestamp);
    var y = date.getFullYear();  
    var m = date.getMonth() + 1;  
    m = m < 10 ? ('0' + m) : m;  
    var d = date.getDate();  
    d = d < 10 ? ('0' + d) : d;  
    var h = date.getHours();
    h = h < 10 ? ('0' + h) : h;
    var minute = date.getMinutes();
    var second = date.getSeconds();
    minute = minute < 10 ? ('0' + minute) : minute;  
    second = second < 10 ? ('0' + second) : second; 
    if(num==0){
        return y + '-' + m + '-' + d;  
    }else if(num==1){
        return y + '-' + m + '-' + d +' '+ h +':'+ minute +':' + second;  
    }else if(num==2){
        // if(y + '-' + m + '-' + d )
        let s1 = y + '-' + m + '-' + d;
        let day = new Date();
        day.setTime(day.getTime());
        let s2 = day.getFullYear()+"-" + ((day.getMonth()+1)<10?'0'+(day.getMonth()+1):(day.getMonth()+1)) + "-" + (day.getDate()<10?'0'+day.getDate():day.getDate());
        if(s1 == s2){
            return '今天'
        }else{
            return m + '月' + d + '日'
        }
    }
}
const GetQueryValue = function(queryName) {
  var reg = new RegExp("(^|&)" + queryName + "=([^&]*)(&|$)", "i");
  var r = window.location.search.substr(1).match(reg);
   if ( r != null ){
     return decodeURI(r[2]);
   }else{
      return null;
   } 
}



export default {
    base64ToFiles,
    s20,
    isPoneFun,
    timeConvert,
    GetQueryValue
}
